import apiClient from './api';
import { Arzt, CreateArztDTO, UpdateArztDTO, AppType } from '../types';

export const arztService = {
  getAllAerzte: async (app?: AppType): Promise<Arzt[]> => {
    const params = app ? { app } : {};
    const response = await apiClient.get('/aerzte', { params });
    return response.data;
  },

  getArztById: async (id: number): Promise<Arzt> => {
    const response = await apiClient.get(`/aerzte/${id}`);
    return response.data;
  },

  createArzt: async (arzt: CreateArztDTO): Promise<Arzt> => {
    const response = await apiClient.post('/aerzte', arzt);
    return response.data;
  },

  updateArzt: async (id: number, arzt: UpdateArztDTO): Promise<Arzt> => {
    const response = await apiClient.put(`/aerzte/${id}`, arzt);
    return response.data;
  },

  deleteArzt: async (id: number): Promise<void> => {
    await apiClient.delete(`/aerzte/${id}`);
  },

  getArztZuweisungen: async (id: number) => {
    const response = await apiClient.get(`/aerzte/${id}/zuweisungen`);
    return response.data;
  },
};
